import { SvgProps } from "components/icons/types";

export const BrowserWindow = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <rect
      x="2"
      y="3"
      width="12"
      height="10"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path d="M2 6H14" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);
